module.exports = "/assets/data/2f6c1785338eb60f4865ae8cdf671b1c-SN10.data.json";